import React from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import autobind from "class-autobind"
import AppStateStore from "../../../stores/AppStateStore"
import { grey700 } from "material-ui/styles/colors"
import AddIVRNumberDialog from "./AddIVRNumberDialog"
interface IProps {
  ivrNumbers: string[]
  readonly: boolean
  handleChange(ipAddresses: string[]): void
}
interface IState {
  ivrNumbers: string[]
  openAddDialog: boolean
  editPhone: string
}

export const transformPhoneNumber = (phone) => {
  const cleaned = phone.replace(/\D/g, "")

  if (cleaned.length === 10) {
      return `+1 (${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
  }

  if (cleaned.length === 11 && cleaned.startsWith("1")) {
      return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`
  }

  return phone
}

export default class IVRNumberChip extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      ivrNumbers: props.ivrNumbers,
      openAddDialog: false,
      editPhone: null
    }
    autobind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ivrNumbers: nextProps.ivrNumbers })
  }

  handleDelete(ipAddress) {
    let ivrNumbers = this.state.ivrNumbers.slice()
    ivrNumbers = ivrNumbers.filter(item => item !== ipAddress)
    this.setState({ ivrNumbers }, () =>
      this.props.handleChange && this.props.handleChange(ivrNumbers)
    )
  }

  handleAdd(breakItem) {
    const ivrNumbers = this.state.ivrNumbers.slice()
    ivrNumbers.push(breakItem)
    this.setState({ ivrNumbers, openAddDialog: false, editPhone: null }, () => {
      this.props.handleChange && this.props.handleChange(ivrNumbers)
    })
  }

  handleUpdate(breakItem) {
    const ivrNumbers = this.state.ivrNumbers.slice()
    const indexOf = this.state.ivrNumbers.indexOf(this.state.editPhone)
    ivrNumbers[indexOf] = breakItem
    this.setState({ ivrNumbers, openAddDialog: false, editPhone: null }, () => {
      this.props.handleChange && this.props.handleChange(ivrNumbers)
    })
  }

  render() {
    return (
      <div style={{ position: "relative" }}>
        {this.props.readonly && !this.state.ivrNumbers.length ?
          <span style={{ color: grey700, fontSize: 14, marginLeft: 5 }}>IVR Phone List</span> :
          <span style={{ color: "rgba(0, 0, 0, 0.3)", fontSize: 13, marginLeft: 5 }}>IVR Phone List</span>
        }
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: -7, paddingBottom: 5 }}>
          {this.state.ivrNumbers.map((item, index) =>
            <Chip
              data-intercom-target={"UpdateIP"}
              style={{ marginTop: 10, marginRight: 5, height: 35 }}
              key={index}
              onRequestDelete={this.props.readonly ?
                null :
                () =>
                  AppStateStore.setConfirmDialogContent({
                    content: "Are you sure you want to remove this IVR Phone Number?",
                    confirm: () => this.handleDelete(item)
                  })
              }
              onClick={() => !this.props.readonly && !AppStateStore.confirmDialogContent &&
                this.setState({ openAddDialog: true, editPhone: item })
              }
              labelStyle={{ width: 120, textAlign: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
            >
              <span>{transformPhoneNumber(item)}</span>
            </Chip>
          )}
          {!this.props.readonly &&
            <IconButton
              data-intercom-target={"IP-Btn-OpenIPAddDialog"}
              style={{ height: 33, marginTop: 2, display: "inline-block" }}
              onTouchTap={() => this.setState({ openAddDialog: true, editPhone: null })}
            >
              <FontIcon className="fa fa-plus-circle" />
            </IconButton>
          }
        </div>
        {this.state.openAddDialog &&
          <AddIVRNumberDialog
            edit={this.state.editPhone}
            hierarchyIPAddresses={this.state.ivrNumbers}
            handleClose={() => this.setState({ openAddDialog: false, editPhone: null })}
            handleAdd={this.handleAdd}
            handleUpdate={this.handleUpdate}
          />
        }
      </div>
    )
  }
}